import Button from '@eg/elements/Button';
import Modal from '@eg/elements/components/Modal';
import React, { FC } from 'react';

export interface SignatureErrorModalProps {
  open: boolean;
  onClick: () => void;
}

export const SignatureErrorModal: FC<SignatureErrorModalProps> = ({ open, onClick }) => (
  <Modal open={open}>
    <p>
      <b>Ups, da ist wohl etwas schief gegangen!</b>
      <br />
      Der Unterschrift-Service ist momentan nicht arreichbar. Versuchen Sie es bitte ernueut, den
      Service aufzurufen.
    </p>
    <br />
    <Button onClick={onClick}>Erneut versuchen</Button>
  </Modal>
);
